var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTemprature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1428 20C20.9299 20 24 16.8396 24 12.9411C24 9.85137 22.0716 7.2253 19.3861 6.26873C19.0045 2.74214 16.0991 0 12.5714 0C8.78434 0 5.71428 3.16034 5.71428 7.05883C5.71428 7.92113 5.86447 8.74725 6.13939 9.51113C5.817 9.44588 5.4838 9.41175 5.14285 9.41175C2.30254 9.41175 0 11.782 0 14.7059C0 17.6297 2.30254 20 5.14285 20H17.1428Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemprature);
export default __webpack_public_path__ + "static/media/temprature.45da3c5f30bbc6956622b399abc26e4d.svg";
export { ForwardRef as ReactComponent };